import React, { Component } from 'react';
import Input from '../CommonComponents/Input';
import Button from '../CommonComponents/Button';

type Props = {
  comment: string;
  onCancel: Function;
  onConfirm: Function;
  onCommentChange: Function;
};
type State = {};

export default class ReleaseChat extends Component<Props, State> {
  render() {
    return (
      <div id='release-chat-wrapper'>
        <Input
          label='Add comment'
          value={this.props.comment}
          onValueChange={this.props.onCommentChange}
        />
        <Button
          text='Release chat'
          theme='dark'
          // disabled={!new RegExp('^\\s*\\w+[\\w,;\'"\\s.?!]*$').test(this.props.comment)}
          onClick={() => {
            // if (this.props.comment) {
            this.props.onConfirm();
            // }
          }}
        />
        <Button
          text='Cancel'
          theme='light'
          onClick={() => {
            this.props.onCancel();
          }}
        />
      </div>
    );
  }
}
